/* Blossom Box Co. theme: shared behaviour on every page.
   Adelaide time and the cut off, header, menu, rails, reveals, toast and the bag count.
   Section scripts (product.js, emblem.js, finder.js, checker.js) use window.BBC from here. */
(function () {
  'use strict';
  var B = window.BBC = window.BBC || {};
  var $ = B.$ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = B.$$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  B.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  B.money = function (cents) { var n = cents / 100; return '$' + (n % 1 === 0 ? n : n.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

  /* ---------- Adelaide time, cut off, dates ---------- */
  var TZ = 'Australia/Adelaide';
  var DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var fmt;
  try { fmt = new Intl.DateTimeFormat('en-AU', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23', weekday: 'short' }); } catch (e) { fmt = null; }
  function adl() {
    var o = {};
    if (fmt) fmt.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    else { var d = new Date(); o = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes(), weekday: DAY[d.getDay()] }; }
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, min: +o.minute, wd: { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[String(o.weekday).slice(0, 3)] };
  }
  B.adl = adl;
  var CUT = +B.cutoff || 14;
  var DELIV = B.deliver && B.deliver.length ? B.deliver : [2, 3, 4, 5, 6];
  var CLOSED = (B.closed || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
  function hoursFor(wd) { var s = String((B.hours || [])[wd] || '').replace(/\s/g, ''); var m = s.match(/^(\d{1,2}(?:\.\d+)?)-(\d{1,2}(?:\.\d+)?)$/); return m ? [+m[1], +m[2]] : null; }
  B.hoursFor = hoursFor;
  function iso(y, m, d) { return y + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d; }
  // day k days from today in Adelaide, as plain calendar values
  function dayAt(k) { var t = adl(), dt = new Date(Date.UTC(t.y, t.m - 1, t.d) + k * 864e5); return { y: dt.getUTCFullYear(), m: dt.getUTCMonth() + 1, d: dt.getUTCDate(), wd: dt.getUTCDay(), iso: iso(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate()) }; }
  B.dayAt = dayAt;
  function isClosed(day) { return CLOSED.indexOf(day.iso) > -1; }
  B.canDeliver = function (day, k) {
    if (DELIV.indexOf(day.wd) < 0 || isClosed(day)) return false;
    if (k === 0) { var t = adl(); return t.h * 60 + t.min < CUT * 60; }
    return k > 0;
  };
  B.canPickup = function (day, k) {
    var h = hoursFor(day.wd); if (!h || isClosed(day)) return false;
    if (k === 0) { var t = adl(), now = t.h + t.min / 60; return now + (+B.pickupLead || 2) <= h[1]; }
    return k > 0;
  };
  B.cutoffState = function () {
    var t = adl(), mins = t.h * 60 + t.min, today = dayAt(0);
    if (B.canDeliver(today, 0)) { var left = CUT * 60 - mins, h = Math.floor(left / 60), m = left % 60; return { today: true, txt: (h ? h + 'h ' : '') + m + 'm' }; }
    for (var k = 1; k < 30; k++) { var d = dayAt(k); if (B.canDeliver(d, k)) return { today: false, next: k === 1 ? 'tomorrow' : k > 6 ? d.d + ' ' + MON[d.m - 1] : DAY[d.wd] }; }
    return { today: false, next: 'soon' };
  };
  B.label = function (day, k) { return k === 0 ? 'Today' : k === 1 ? 'Tomorrow' : DAY[day.wd]; };
  B.short = function (day) { return day.d + ' ' + MON[day.m - 1]; };
  B.long = function (day) { return DAY[day.wd] + ' ' + day.d + ' ' + MONTH[day.m - 1] + ' ' + day.y; };
  B.DAY = DAY;
  function hr(h) { var hh = Math.floor(h), mm = Math.round((h - hh) * 60); return (hh > 12 ? hh - 12 : hh) + (mm ? '.' + (mm < 10 ? '0' : '') + mm : '') + (hh >= 12 ? 'pm' : 'am'); }
  B.hr = hr;
  function openState() {
    var t = adl(), now = t.h + t.min / 60, today = dayAt(0), r = isClosed(today) ? null : hoursFor(t.wd);
    if (r && now >= r[0] && now < r[1]) return { open: true, txt: 'Open now until ' + hr(r[1]) };
    if (r && now < r[0]) return { open: false, txt: 'Opens today at ' + hr(r[0]) };
    for (var k = 1; k < 30; k++) { var d = dayAt(k), h = isClosed(d) ? null : hoursFor(d.wd); if (h) return { open: false, txt: 'Closed now. Opens ' + (k === 1 ? 'tomorrow' : k > 6 ? DAY[d.wd] + ' ' + d.d + ' ' + MON[d.m - 1] : DAY[d.wd]) + ' at ' + hr(h[0]) }; }
    return { open: false, txt: 'Closed now' };
  }
  function fill(el, c, a, b) { el.innerHTML = c.today ? a.replace('[time]', '<b>' + c.txt + '</b>') : b.replace('[day]', c.next); }
  function tick() {
    var c = B.cutoffState();
    $$('[data-cut]').forEach(function (e) {
      fill(e, c, e.getAttribute('data-before') || 'Order within [time] for same day delivery', e.getAttribute('data-after') || 'Order now for delivery [day]');
    });
    $$('[data-cut-short]').forEach(function (e) { fill(e, c, 'Order within [time] for delivery today', 'Order now for delivery [day]'); });
    $$('[data-cut-mini]').forEach(function (e) { e.innerHTML = c.today ? 'Shop now &middot; ' + c.txt + ' left' : 'Shop now'; });
    $$('[data-open]').forEach(function (st) {
      var o = openState(); var s = st.querySelector('[data-open-txt]'); if (s) s.textContent = o.txt;
      var dot = st.querySelector('.dot'); if (dot) dot.classList.toggle('shut', !o.open);
    });
    var wd = adl().wd;
    $$('[data-days]').forEach(function (r) { r.classList.toggle('today', r.getAttribute('data-days').split(',').map(function (x) { return x.trim(); }).indexOf(String(wd)) > -1); });
  }
  B.tick = tick;

  /* ---------- toast ---------- */
  var tT;
  B.toast = function (msg, showLink) {
    var t = $('#toast'); if (!t) return;
    $('#toastMsg').textContent = msg; $('#toastLink').hidden = !showLink;
    t.classList.add('on'); clearTimeout(tT); tT = setTimeout(function () { t.classList.remove('on'); }, 4200);
  };

  /* ---------- bag count and add to cart ---------- */
  B.setCount = function (n, bump) {
    $$('[data-cart-count]').forEach(function (c) {
      c.textContent = n; c.classList.toggle('on', n > 0); c.classList.remove('bump');
      if (bump) { void c.offsetWidth; c.classList.add('bump'); }
    });
    $$('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Bag, ' + n + ' item' + (n === 1 ? '' : 's')); });
  };
  B.addToCart = function (items) {
    return fetch(B.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function () { return fetch(B.routes.cart + '.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { B.setCount(cart.item_count, true); document.dispatchEvent(new CustomEvent('bbc:cart', { detail: cart })); return B.syncAttributes(cart).then(function () { return cart; }); });
  };

  /* ---------- order level delivery details (what Bird used to write) ----------
     Each line keeps its own date and card message. The order also gets one summary,
     so EasyRoutes, Order Printer and the order page show the date without opening every line. */
  B.syncAttributes = function (cart) {
    var items = (cart.items || []).filter(function (i) { return i.properties && (i.properties['Delivery method'] || i.properties['Delivery date'] || i.properties['Pick up date']); });
    var dates = {}, methods = {}, isos = [];
    items.forEach(function (i) {
      var p = i.properties, d = p['Delivery date'] || p['Pick up date'];
      methods[p['Delivery method'] || 'Delivery'] = 1;
      if (d) { dates[d] = (dates[d] || []).concat(i.product_title); if (p._date) isos.push(p._date); } // posted lines carry no date
    });
    var keys = Object.keys(dates), want = {};
    if (keys.length === 1) want['Delivery date'] = keys[0];
    else if (keys.length > 1) want['Delivery date'] = 'Several dates: ' + keys.map(function (k) { return k + ' (' + dates[k].join(', ') + ')'; }).join('; ');
    else want['Delivery date'] = '';
    want['Delivery method'] = Object.keys(methods).join(' and ');
    want['Delivery date ISO'] = isos.sort()[0] || '';
    var cur = cart.attributes || {};
    if (Object.keys(want).every(function (k) { return (cur[k] || '') === want[k]; })) return Promise.resolve(cart);
    return fetch(B.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: want }) }).catch(function () {});
  };

  /* ---------- overlays (menu) ---------- */
  var openEl = null, lastFocus = null;
  B.open = function (el) {
    if (!el) return; if (openEl) B.close(true); lastFocus = document.activeElement; openEl = el;
    el.removeAttribute('inert'); el.classList.add('on'); var s = $('#scrim'); if (s) s.classList.add('on'); document.body.style.overflow = 'hidden';
    setTimeout(function () { var f = el.querySelector('[data-shut],button,a'); if (f) f.focus({ preventScroll: true }); }, 60);
  };
  B.close = function (silent) {
    if (!openEl) return; var el = openEl; el.classList.remove('on'); el.setAttribute('inert', ''); var s = $('#scrim'); if (s) s.classList.remove('on');
    document.body.style.overflow = ''; openEl = null; $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!silent && lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  };

  /* ---------- rails ---------- */
  function rails(root) {
    $$('.rail', root).forEach(function (rail) {
      if (rail._r) return; rail._r = 1;
      var sec = rail.closest('section') || rail.parentNode, thumb = sec.querySelector('.rail-bar i'), btns = $$('.rail-btn', sec);
      function scrollable() { return rail.scrollWidth - rail.clientWidth > 4; }
      function stops() {
        var r = rail.getBoundingClientRect().left, pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0, max = rail.scrollWidth - rail.clientWidth, out = [];
        Array.prototype.forEach.call(rail.children, function (k) { var v = Math.round(k.getBoundingClientRect().left - r + rail.scrollLeft - pad); v = Math.max(0, Math.min(max, v)); if (out.indexOf(v) < 0) out.push(v); });
        return out;
      }
      function target(dir) {
        var sl = rail.scrollLeft, st = stops(), best = st[0];
        if (dir > 0) { best = st.filter(function (v) { return v > sl + 4; })[0]; if (best === undefined) best = st[st.length - 1]; }
        else if (dir < 0) { var lo = st.filter(function (v) { return v < sl - 4; }); best = lo.length ? lo[lo.length - 1] : 0; }
        else st.forEach(function (v) { if (Math.abs(v - sl) < Math.abs(best - sl)) best = v; });
        return best;
      }
      function ui() {
        rail.classList.toggle('can-drag', scrollable()); if (!thumb) return;
        var w = rail.scrollWidth, v = rail.clientWidth, p = Math.min(1, v / w);
        thumb.style.width = (p * 100) + '%'; thumb.style.left = ((rail.scrollLeft / ((w - v) || 1)) * (1 - p) * 100) + '%';
      }
      var t, drag = null, moved = false, suppress = false;
      rail.addEventListener('scroll', function () { ui(); if (drag) return; clearTimeout(t); t = setTimeout(function () { if (!scrollable() || drag) return; var g = target(0); if (Math.abs(g - rail.scrollLeft) > 2) rail.scrollTo({ left: g, behavior: 'smooth' }); }, 160); }, { passive: true });
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0 || !scrollable()) return; drag = { x: e.clientX, sl: rail.scrollLeft }; moved = false; });
      window.addEventListener('pointermove', function (e) { if (!drag) return; var dx = e.clientX - drag.x; if (!moved && Math.abs(dx) > 6) { moved = true; rail.classList.add('dragging'); } if (moved) rail.scrollLeft = drag.sl - dx; });
      window.addEventListener('pointerup', function (e) {
        if (!drag) return; var dx = e.clientX - drag.x; drag = null; if (!moved) return; moved = false; suppress = true; setTimeout(function () { suppress = false; }, 0);
        var tg = target(Math.abs(dx) < 40 ? 0 : (dx < 0 ? 1 : -1)), n = 0; rail.scrollTo({ left: tg, behavior: 'smooth' });
        (function chk() { if (Math.abs(rail.scrollLeft - tg) < 2 || n++ > 90) rail.classList.remove('dragging'); else requestAnimationFrame(chk); })();
      });
      rail.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
      btns.forEach(function (b) { b.addEventListener('click', function () { rail.scrollTo({ left: target(+b.getAttribute('data-dir')), behavior: 'smooth' }); }); });
      window.addEventListener('resize', ui); ui();
    });
  }
  B.rails = rails;

  /* ---------- radio groups made of buttons ---------- */
  B.radio = function (group, btn) { $$('[role="radio"]', group).forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); b.tabIndex = b === btn ? 0 : -1; }); };
  B.roving = function (root) { $$('[role="radiogroup"]', root).forEach(function (g) { var r = $$('[role="radio"]', g); var on = r.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0] || r[0]; r.forEach(function (b) { b.tabIndex = b === on ? 0 : -1; }); }); };

  /* ---------- reveals ---------- */
  var io = null;
  function reveals(root) {
    var els = $$('.rv', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    if (!io) io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- sticky bar shown once an element scrolls away (and hidden while a quiet section is on screen) ---------- */
  B.stickyAfter = function (watch, bar, quiet) {
    if (!watch || !bar || !('IntersectionObserver' in window)) return;
    var past = false, inQuiet = false;
    function set() { bar.classList.toggle('show', past && !inQuiet); }
    new IntersectionObserver(function (en) { en.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; }); set(); }).observe(watch);
    if (quiet) new IntersectionObserver(function (en) { en.forEach(function (x) { inQuiet = x.isIntersecting; }); set(); }).observe(quiet);
  };

  function init(root) {
    rails(root); reveals(root); B.roving(root); tick();
  }
  B.init = init;

  document.addEventListener('DOMContentLoaded', function () {
    var hdr = $('#hdr');
    function onScroll() { if (hdr) hdr.classList.toggle('scrolled', window.scrollY > 8); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    // wide screens: if the links ever outgrow the header (more or longer links in the menu), use the menu button
    function fitNav() {
      if (!hdr) return; hdr.classList.remove('hdr--fit');
      var row = hdr.querySelector('.hdr-row'), nav = hdr.querySelector('.nav');
      if (!row || !nav || getComputedStyle(nav).display === 'none') return;
      if (row.scrollWidth > row.clientWidth + 1) hdr.classList.add('hdr--fit');
    }
    var fitT; fitNav(); window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitNav, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
    $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { var m = document.getElementById(b.getAttribute('aria-controls')); B.open(m); b.setAttribute('aria-expanded', 'true'); }); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-shut]') || e.target.id === 'scrim') B.close();
      var a = e.target.closest('.menu a[href*="#"]'); if (a) B.close(true);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') B.close();
      if (e.key === 'Tab' && openEl) {
        var f = $$('button:not([disabled]),a[href],textarea,input:not([type="hidden"]),summary', openEl).filter(function (x) { return x.offsetParent !== null; }); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
      var r = e.target.closest && e.target.closest('[role="radio"]');
      if (r && ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) > -1) {
        var g = r.parentElement, list = $$('[role="radio"]:not([disabled])', g), i = list.indexOf(r);
        var n = list[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length]; e.preventDefault(); n.focus(); n.click();
      }
    });
    // desktop dropdowns: close others, close on outside click
    document.addEventListener('click', function (e) { $$('.nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); }); });
    init(document);
    setInterval(tick, 30000);
    // the bag page: keep the order level delivery summary right after lines are changed or removed
    if (document.body.classList.contains('t-cart')) fetch(B.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(B.syncAttributes).catch(function () {});
    // home sticky bar after the hero; out of the way while the Emblem Box builder (its own button) is on screen
    B.stickyAfter($('[data-hero]'), $('#mbar'), $('[data-emblem]'));
  });
  // theme editor: re-run when a section is added or changed
  document.addEventListener('shopify:section:load', function (e) { init(e.target); document.dispatchEvent(new CustomEvent('bbc:section', { detail: e.target })); });
})();

/* Product photos (21 Oct 2026, replaces the 19 Oct frames). Every product photo fills its box, cropped
   round the product and centred, whatever the shape or framing of the photo Trinh or staff upload.
   Mark a box with class "fr" (position relative, a fixed size) holding one img; data-ow on the img is the
   uploaded photo's width, so a photo is never zoomed past its own sharpness.
   1. Find the product, in a small copy of the photo (240 wide, so every screen crops it the same way): the
      backdrop (studio wall, plinth, table, a transparent background) runs in from the photo's edges in
      smooth steps; what is left, less thin lines such as plinth edges, is the product.
   2. Show the part of the photo where the product fills about 80% of the box, centred, zoomed in at most
      2.5 times past filling the box.
   3. A product too wide (or tall) for the box: on a plain backdrop the backdrop carries on past the photo
      so the whole product shows; on a busy one the photo is cropped to fill, centred on the product.
   4. Nothing found, or a photo the browser may not read: the photo fills the box from its centre.
   The photo stays hidden until it is placed (class fr-wait on html, set in the layout), so it never jumps. */
(function () {
  'use strict';
  var S = 100, AN = 240, F = 0.8, FF = 0.9, ZMAX = 2.5, CUT = 0.12, SHARP = 1.25, cv, cx, ro, io, got = {};
  function done(img) { img.classList.add('is-fr'); }
  // the product's box in the photo, 0..1 units, or null
  function product(d, w, h) {
    var T1 = 7, T2 = 16, G = 5, n = w * h, i, x, y, k;
    // 3x3 blur to calm texture and JPEG noise
    var c = new Float32Array(n * 3);
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      var r = 0, g = 0, b = 0, m = 0;
      for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
        var xx = x + dx, yy = y + dy;
        if (xx < 0 || yy < 0 || xx >= w || yy >= h) continue;
        var p = (yy * w + xx) * 4; r += d[p]; g += d[p + 1]; b += d[p + 2]; m++;
      }
      i = (y * w + x) * 3; c[i] = r / m; c[i + 1] = g / m; c[i + 2] = b / m;
    }
    function dist(a, b) { a *= 3; b *= 3; return Math.max(Math.abs(c[a] - c[b]), Math.abs(c[a + 1] - c[b + 1]), Math.abs(c[a + 2] - c[b + 2])); }
    // local contrast: the biggest step to a neighbour
    var grad = new Float32Array(n);
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; var gm = 0;
      if (x > 0) gm = Math.max(gm, dist(i, i - 1));
      if (x < w - 1) gm = Math.max(gm, dist(i, i + 1));
      if (y > 0) gm = Math.max(gm, dist(i, i - w));
      if (y < h - 1) gm = Math.max(gm, dist(i, i + w));
      grad[i] = gm;
    }
    // 1. backdrop: spread in from every edge pixel through smooth steps
    var bg = new Uint8Array(n), q = new Int32Array(n), qh = 0, qt = 0, pal = [];
    for (x = 0; x < w; x++) { q[qt++] = x; q[qt++] = (h - 1) * w + x; }
    for (y = 1; y < h - 1; y++) { q[qt++] = y * w; q[qt++] = y * w + w - 1; }
    for (k = 0; k < qt; k++) { bg[q[k]] = 1; }
    // palette of edge colours (8 level buckets)
    var seen = {};
    for (k = 0; k < qt; k++) {
      i = q[k] * 3; var key = (c[i] >> 3) + ',' + (c[i + 1] >> 3) + ',' + (c[i + 2] >> 3);
      if (!seen[key]) { seen[key] = 1; pal.push([c[i], c[i + 1], c[i + 2]]); }
    }
    while (qh < qt) {
      var p0 = q[qh++], px = p0 % w, py = (p0 - px) / w, nb = [];
      if (px > 0) nb.push(p0 - 1); if (px < w - 1) nb.push(p0 + 1); if (py > 0) nb.push(p0 - w); if (py < h - 1) nb.push(p0 + w);
      for (k = 0; k < nb.length; k++) { var nq = nb[k]; if (!bg[nq] && dist(p0, nq) <= T1) { bg[nq] = 1; q[qt++] = nq; } }
    }
    // 2. smooth patches the colour of the edges are backdrop too (a plinth top cut off by its outline)
    for (i = 0; i < n; i++) {
      if (bg[i] || grad[i] > G) continue;
      var j = i * 3, best = 1e9;
      for (k = 0; k < pal.length; k++) {
        var e = Math.max(Math.abs(c[j] - pal[k][0]), Math.abs(c[j + 1] - pal[k][1]), Math.abs(c[j + 2] - pal[k][2]));
        if (e < best) best = e; if (best <= T2) break;
      }
      if (best <= T2) bg[i] = 2;
    }
    // 3. pieces of product: connected areas that are not backdrop, after thin lines (plinth and table edges) are opened away
    var er = new Uint8Array(n), op = new Uint8Array(n);
    for (y = 1; y < h - 1; y++) for (x = 1; x < w - 1; x++) {
      i = y * w + x; if (bg[i]) continue; var all = 1;
      for (var ey = -1; ey <= 1 && all; ey++) for (var ex = -1; ex <= 1; ex++) if (bg[i + ey * w + ex]) { all = 0; break; }
      er[i] = all;
    }
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; if (bg[i]) continue;
      for (var oy = -1; oy <= 1 && !op[i]; oy++) for (var ox = -1; ox <= 1; ox++) { var xx2 = x + ox, yy2 = y + oy; if (xx2 >= 0 && yy2 >= 0 && xx2 < w && yy2 < h && er[yy2 * w + xx2]) { op[i] = 1; break; } }
    }
    var lab = new Int32Array(n), comps = [], id = 0;
    for (i = 0; i < n; i++) {
      if (!op[i] || lab[i]) continue;
      id++; var cm = { a: 0, x0: w, y0: h, x1: 0, y1: 0 }; qh = qt = 0; q[qt++] = i; lab[i] = id;
      while (qh < qt) {
        var p1 = q[qh++], ax = p1 % w, ay = (p1 - ax) / w; cm.a++;
        if (ax < cm.x0) cm.x0 = ax; if (ax > cm.x1) cm.x1 = ax; if (ay < cm.y0) cm.y0 = ay; if (ay > cm.y1) cm.y1 = ay;
        var nn = [];
        if (ax > 0) nn.push(p1 - 1); if (ax < w - 1) nn.push(p1 + 1); if (ay > 0) nn.push(p1 - w); if (ay < h - 1) nn.push(p1 + w);
        for (k = 0; k < nn.length; k++) if (op[nn[k]] && !lab[nn[k]]) { lab[nn[k]] = id; q[qt++] = nn[k]; }
      }
      comps.push(cm);
    }
    if (!comps.length) return null;
    var big = 0; comps.forEach(function (m) { if (m.a > big) big = m.a; });
    var keep = comps.filter(function (m) {
      var bw = m.x1 - m.x0 + 1, bh = m.y1 - m.y0 + 1, fill = m.a / (bw * bh);
      return m.a >= Math.max(n * 0.002, big * 0.04) && (fill >= 0.12 || m.a >= n * 0.03);
    });
    if (!keep.length) return null;
    var X0 = w, Y0 = h, X1 = 0, Y1 = 0, A = 0;
    keep.forEach(function (m) { X0 = Math.min(X0, m.x0); Y0 = Math.min(Y0, m.y0); X1 = Math.max(X1, m.x1); Y1 = Math.max(Y1, m.y1); A += m.a; });
    if (A < n * 0.004) return null;
    // on a plain even backdrop (a cut out on white) every mark that is not the backdrop counts, so faint glass is kept
    var lo = 255, hi = 0, mr = 0, mg = 0, mb = 0, nb2 = 0;
    for (x = 0; x < w; x++) for (k = 0; k < 2; k++) { var e0 = (k ? (h - 1) * w + x : x) * 3; var L0 = (c[e0] + c[e0 + 1] + c[e0 + 2]) / 3; lo = Math.min(lo, L0); hi = Math.max(hi, L0); mr += c[e0]; mg += c[e0 + 1]; mb += c[e0 + 2]; nb2++; }
    for (y = 0; y < h; y++) for (k = 0; k < 2; k++) { var e1 = (k ? y * w + w - 1 : y * w) * 3; var L1 = (c[e1] + c[e1 + 1] + c[e1 + 2]) / 3; lo = Math.min(lo, L1); hi = Math.max(hi, L1); mr += c[e1]; mg += c[e1 + 1]; mb += c[e1 + 2]; nb2++; }
    if (hi - lo <= 12) {
      mr /= nb2; mg /= nb2; mb /= nb2;
      var mk = new Uint8Array(n), lab2 = new Int32Array(n), id2 = 0;
      for (i = 0; i < n; i++) { var j2 = i * 3; if (Math.max(Math.abs(c[j2] - mr), Math.abs(c[j2 + 1] - mg), Math.abs(c[j2 + 2] - mb)) > 14) mk[i] = 1; }
      for (i = 0; i < n; i++) {
        if (!mk[i] || lab2[i]) continue;
        var ca = 0, cx0 = w, cy0 = h, cx1 = 0, cy1 = 0; id2++; qh = qt = 0; q[qt++] = i; lab2[i] = id2;
        while (qh < qt) {
          var a2 = q[qh++], bx = a2 % w, by = (a2 - bx) / w; ca++;
          if (bx < cx0) cx0 = bx; if (bx > cx1) cx1 = bx; if (by < cy0) cy0 = by; if (by > cy1) cy1 = by;
          var n2 = [];
          if (bx > 0) n2.push(a2 - 1); if (bx < w - 1) n2.push(a2 + 1); if (by > 0) n2.push(a2 - w); if (by < h - 1) n2.push(a2 + w);
          for (k = 0; k < n2.length; k++) if (mk[n2[k]] && !lab2[n2[k]]) { lab2[n2[k]] = id2; q[qt++] = n2[k]; }
        }
        if (ca >= 4) { X0 = Math.min(X0, cx0); Y0 = Math.min(Y0, cy0); X1 = Math.max(X1, cx1); Y1 = Math.max(Y1, cy1); }
      }
    }
    // 4. thin parts that belong to it, from the mask before opening
    var lab3 = new Int32Array(n), raw = [];
    for (i = 0; i < n; i++) {
      if (bg[i] || lab3[i]) continue;
      var rm = { a: 0, x0: w, y0: h, x1: 0, y1: 0, sx0: w, sx1: -1, sy0: h, sy1: -1 }; qh = qt = 0; q[qt++] = i; lab3[i] = 1;
      while (qh < qt) {
        var a3 = q[qh++], cx3 = a3 % w, cy3 = (a3 - cx3) / w; rm.a++;
        if (cx3 < rm.x0) rm.x0 = cx3; if (cx3 > rm.x1) rm.x1 = cx3; if (cy3 < rm.y0) rm.y0 = cy3; if (cy3 > rm.y1) rm.y1 = cy3;
        // the part of it out to the sides of the product, level with it
        if ((cx3 < X0 || cx3 > X1) && cy3 >= Y0 && cy3 <= Y1) { rm.sx0 = Math.min(rm.sx0, cx3); rm.sx1 = Math.max(rm.sx1, cx3); rm.sy0 = Math.min(rm.sy0, cy3); rm.sy1 = Math.max(rm.sy1, cy3); }
        var n3 = [];
        if (cx3 > 0) n3.push(a3 - 1); if (cx3 < w - 1) n3.push(a3 + 1); if (cy3 > 0) n3.push(a3 - w); if (cy3 < h - 1) n3.push(a3 + w);
        for (k = 0; k < n3.length; k++) if (!bg[n3[k]] && !lab3[n3[k]]) { lab3[n3[k]] = 1; q[qt++] = n3[k]; }
      }
      raw.push(rm);
    }
    var BX0 = X0, BX1 = X1, BH = Y1 - Y0 + 1;
    raw.forEach(function (m) {
      if (m.a < n * 0.001) return;
      // walls out to the sides (a hamper box, an acrylic case) that run most of its height; a plinth edge is only a line
      if (m.sy1 >= 0 && m.sy1 - m.sy0 + 1 >= 0.5 * BH) { X0 = Math.min(X0, m.sx0); X1 = Math.max(X1, m.sx1); }
      var mw = m.x1 - m.x0 + 1, ov = Math.min(m.x1, BX1) - Math.max(m.x0, BX0) + 1;
      // rising above it (glass, twigs) or hanging below it (stems, a bouquet's wrapped base), but not a plinth edge wider than it
      if (m.y0 < Y0 && m.y1 >= Y0 && ov >= 0.5 * mw) Y0 = m.y0;
      if (m.y1 > Y1 && m.y0 <= Y1 && ov >= 0.7 * mw && mw <= 1.2 * (BX1 - BX0 + 1)) Y1 = m.y1;
    });
    return { x: X0 / w, y: Y0 / h, w: (X1 - X0 + 1) / w, h: (Y1 - Y0 + 1) / h };
  }
  // one side's outer line: its colours (smoothed along the side) when plain enough to carry on, else null
  function edge(d, w, h, side) {
    var horiz = side === 't' || side === 'b', n = horiz ? w : h, cols = [], steps = [], chroma = 0, i, k;
    for (i = 0; i < n; i++) {
      var col = [0, 0, 0];
      for (k = 0; k < 2; k++) {
        var x = horiz ? i : (side === 'l' ? k : w - 1 - k), y = horiz ? (side === 't' ? k : h - 1 - k) : i, p = (y * w + x) * 4;
        col[0] += d[p] / 2; col[1] += d[p + 1] / 2; col[2] += d[p + 2] / 2;
        if (k === 0) chroma = Math.max(chroma, Math.max(d[p], d[p + 1], d[p + 2]) - Math.min(d[p], d[p + 1], d[p + 2]));
      }
      cols.push(col);
      if (i) steps.push(Math.abs((0.299 * col[0] + 0.587 * col[1] + 0.114 * col[2]) - (0.299 * cols[i - 1][0] + 0.587 * cols[i - 1][1] + 0.114 * cols[i - 1][2])));
    }
    steps.sort(function (a, b) { return b - a; });
    // a backdrop may have a hard line or two (wall to floor); more is detail; strong colour would smear
    var rest = steps.slice(2).reduce(function (t, v) { return t + v; }, 0) / Math.max(1, steps.length - 2);
    if (rest > 2.2 || chroma > 40) return null;
    var r = Math.max(1, Math.round(n / 12));
    return cols.map(function (_, i) {
      var s = [0, 0, 0], m = 0;
      for (var j = Math.max(0, i - r); j <= Math.min(n - 1, i + r); j++) { s[0] += cols[j][0]; s[1] += cols[j][1]; s[2] += cols[j][2]; m++; }
      return [s[0] / m, s[1] / m, s[2] / m];
    });
  }
  function rgb(c) { return 'rgb(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ')'; }
  // the colours along a side, for the part of it in view (from, span: 0..1 of the side)
  function grad(dir, cols, from, span) {
    var n = cols.length, out = [];
    for (var i = 0; i <= 24; i++) {
      var u = from + span * i / 24, j = Math.min(n - 1, Math.max(0, u * n - 0.5)), a = Math.floor(j), t = j - a, b = Math.min(n - 1, a + 1);
      out.push(rgb([0, 1, 2].map(function (k) { return cols[a][k] * (1 - t) + cols[b][k] * t; })) + ' ' + (i * 100 / 24).toFixed(1) + '%');
    }
    return 'linear-gradient(' + dir + ',' + out.join(',') + ')';
  }
  function read(img) {
    var r = img.naturalWidth / img.naturalHeight, w = r >= 1 ? S : Math.max(4, Math.round(S * r)), h = r >= 1 ? Math.max(4, Math.round(S / r)) : S, d;
    cv = cv || document.createElement('canvas'); cv.width = w; cv.height = h;
    cx = cx || cv.getContext('2d', { willReadFrequently: true });
    cx.fillStyle = '#fff'; cx.fillRect(0, 0, w, h); cx.drawImage(img, 0, 0, w, h);
    d = cx.getImageData(0, 0, w, h).data;
    return { bb: product(d, w, h), e: { t: edge(d, w, h, 't'), b: edge(d, w, h, 'b'), l: edge(d, w, h, 'l'), r: edge(d, w, h, 'r') } };
  }
  function safe(img) { try { return read(img); } catch (err) { return {}; } } // a photo the browser may not read fills from the centre
  // the photo is read from its own small file (240 wide, always JPEG), so every phone and screen crops it the same way
  function small(img) {
    var u = img.getAttribute('src') || '', i = u.indexOf('?');
    if (u.indexOf('/cdn/shop/') < 0) return null;
    var keep = i < 0 ? [] : u.slice(i + 1).split('&').filter(function (p) { return p && !/^(?:width|height|crop|format)=/.test(p); });
    return (i < 0 ? u : u.slice(0, i)) + '?' + keep.concat('width=' + AN, 'format=pjpg').join('&');
  }
  function analyse(img, cb) {
    var u = small(img), c;
    if (!u) return cb(null);
    c = got[u];
    if (!c) {
      c = got[u] = { cbs: [] };
      var a = new Image();
      a.onload = function () { c.res = safe(a); c.cbs.forEach(function (f) { f(c.res); }); c.cbs = null; };
      a.onerror = function () { c.res = null; c.cbs.forEach(function (f) { f(null); }); c.cbs = null; };
      a.src = u;
    }
    if (c.cbs) c.cbs.push(cb); else cb(c.res);
  }
  function place(img) {
    var box = img.parentNode, bw = box.clientWidth, bh = box.clientHeight, info = img._fr || {};
    if (!bw || !bh || !img.naturalWidth) return;
    var ar = img.naturalWidth / img.naturalHeight, k = (bw / bh) / ar, cw = k <= 1 ? k : 1, ch = k <= 1 ? 1 : 1 / k;
    var bb = info.bb, e = info.e || {}, ow = +img.getAttribute('data-ow') || 0, ww = cw, fit = false;
    if (bb) {
      // never zoom past the photo's own sharpness: at least SHARP photo pixels per screen pixel
      var zmax = ow ? Math.min(ZMAX, Math.max(1, ow * cw / (bw * SHARP))) : ZMAX;
      var need = Math.max(bb.w / F, bb.h / F * k, cw / zmax);
      if (need <= cw) ww = need;
      else if (Math.max((bb.w - cw) / bb.w, (bb.h - ch) / bb.h) > CUT && (k <= 1 ? e.t && e.b : e.l && e.r)) {
        ww = Math.max(bb.w / FF, bb.h / FF * k, cw); ww = Math.min(ww, k <= 1 ? 1 : k); fit = true;
      }
    } else bb = { x: 0, y: 0, w: 1, h: 1 };
    var wh = ww / k;
    function at(c, s) { var v = c - s / 2; return s <= 1 ? Math.min(Math.max(v, 0), 1 - s) : Math.min(Math.max(v, 1 - s), 0); }
    var x = at(bb.x + bb.w / 2, ww), y = at(bb.y + bb.h / 2, wh), st = img.style, P = 4;
    st.width = (100 / ww).toFixed(3) + '%'; st.height = (100 / wh).toFixed(3) + '%';
    st.left = (-100 * x / ww).toFixed(3) + '%'; st.top = (-100 * y / wh).toFixed(3) + '%';
    st.transformOrigin = ((x + ww / 2) * 100).toFixed(2) + '% ' + ((y + wh / 2) * 100).toFixed(2) + '%';
    // the backdrop carried on past the photo, with the photo's edge faded into it
    var layers = [], mask = '';
    if (fit) {
      var f, lo = -y / wh, hi = (y + wh - 1) / wh, le = -x / ww, ri = (x + ww - 1) / ww;
      if (k <= 1) {
        f = P / 100 / wh;
        if (lo > 0.001) layers.push(grad('to right', e.t, x, ww) + ' top/100% ' + ((lo + f) * 100).toFixed(2) + '% no-repeat');
        if (hi > 0.001) layers.push(grad('to right', e.b, x, ww) + ' bottom/100% ' + ((hi + f) * 100).toFixed(2) + '% no-repeat');
        mask = 'linear-gradient(to bottom,' + (lo > 0.001 ? 'transparent 0,#000 ' + P + '%' : '#000 0') + ',' + (hi > 0.001 ? '#000 ' + (100 - P) + '%,transparent 100%' : '#000 100%') + ')';
      } else {
        f = P / 100 / ww;
        if (le > 0.001) layers.push(grad('to bottom', e.l, y, wh) + ' left/' + ((le + f) * 100).toFixed(2) + '% 100% no-repeat');
        if (ri > 0.001) layers.push(grad('to bottom', e.r, y, wh) + ' right/' + ((ri + f) * 100).toFixed(2) + '% 100% no-repeat');
        mask = 'linear-gradient(to right,' + (le > 0.001 ? 'transparent 0,#000 ' + P + '%' : '#000 0') + ',' + (ri > 0.001 ? '#000 ' + (100 - P) + '%,transparent 100%' : '#000 100%') + ')';
      }
    }
    box.style.background = layers.join(',');
    st.webkitMaskImage = st.maskImage = mask;
    // ask for a bigger file when the photo is shown bigger than its box
    var shown = Math.ceil(bw / ww);
    if (img.srcset) { if (shown > bw * 1.05 && img.sizes !== shown + 'px') img.sizes = shown + 'px'; }
    else {
      var m = /([?&]width=)(\d+)/.exec(img.src), want = Math.min(1920, Math.ceil(shown * Math.min(window.devicePixelRatio || 1, 2) / 96) * 96);
      if (m && want > +m[2] * 1.1) img.src = img.src.replace(m[0], m[1] + want);
    }
  }
  function loaded(img, cb) {
    if (img.complete) return cb();
    img.addEventListener('load', cb, { once: true }); img.addEventListener('error', cb, { once: true });
  }
  function frame(img) {
    if (img._frw || !img.parentNode || !img.parentNode.classList.contains('fr')) return;
    img._frw = 1;
    analyse(img, function (res) {
      loaded(img, function () {
        if (img._fr) return;
        img._fr = res || (img.naturalWidth ? safe(img) : {});
        try { place(img); } catch (err) {}
        done(img);
        if (ro) ro.observe(img.parentNode);
      });
    });
  }
  if (window.ResizeObserver) ro = new ResizeObserver(function (list) {
    list.forEach(function (en) { var img = en.target.querySelector(':scope>img'); if (img && img._fr) place(img); });
  });
  // start on each photo as it comes within a screen or so of view, so its small file is ready when the photo is
  if (window.IntersectionObserver) io = new IntersectionObserver(function (list) {
    list.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); var img = en.target.querySelector(':scope>img'); if (img) frame(img); } });
  }, { rootMargin: '800px' });
  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('.fr>img'), function (img) {
      if (img._frw || img._fro) return;
      if (io && !img.complete) { img._fro = 1; io.observe(img.parentNode); } else frame(img);
    });
  }
  document.addEventListener('load', function (ev) { var t = ev.target; if (t.tagName === 'IMG' && t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('fr')) frame(t); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  window.BBfr = 1;
})();

/* Page and policy text (22 Oct 2026). Text pasted into Shopify's editor (pages, policies, descriptions) brings its
   own spacing: blank lines, bold lines used as headings, two line breaks between paragraphs. Tidied here so
   every page reads the same (base.css sets the spaces):
   - a line holding nothing but spaces and line breaks goes (base.css puts the same space between all paragraphs);
   - two line breaks in a row inside a paragraph start a new paragraph;
   - a bold line on its own, or bold words followed by a line break at the start of a paragraph, is a subheading. */
(function () {
  'use strict';
  var WS = /[\s ​]+/g;
  function txt(n) { return (n.textContent || '').replace(WS, ' ').trim(); }
  function blank(el) { return !txt(el) && !el.querySelector('img,iframe,video,svg,table,hr,input'); }
  function quiet(n) { return n && n.nodeType === 3 && !txt(n); }
  // every word in the element is bold
  function allBold(el) {
    var t = txt(el); if (!t || t.length > 90 || el.querySelector('img,ul,ol,table,h1,h2,h3,h4')) return false;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) { if (txt(n)) { var b = n.parentElement.closest('strong,b'); if (!b || !el.contains(b)) return false; } }
    return true;
  }
  function head(text) { var d = document.createElement('div'); d.className = 'rte-h'; d.textContent = text; return d; }
  // split a paragraph at two line breaks in a row (direct children only)
  function split(el) {
    var parts = [[]], kids = Array.prototype.slice.call(el.childNodes), i, j;
    for (i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.nodeName === 'BR') {
        j = i + 1; while (quiet(kids[j])) j++;
        if (kids[j] && kids[j].nodeName === 'BR') { while (kids[j] && (kids[j].nodeName === 'BR' || quiet(kids[j]))) j++; parts.push([]); i = j - 1; continue; }
      }
      parts[parts.length - 1].push(k);
    }
    if (parts.length < 2) return [el];
    var out = parts.map(function (nodes) {
      var e = document.createElement(el.nodeName === 'DIV' ? 'div' : 'p');
      if (el.className) e.className = el.className;
      nodes.forEach(function (n) { e.appendChild(n); });
      return e;
    }).filter(function (e) { return !blank(e); });
    out.forEach(function (e) { el.parentNode.insertBefore(e, el); });
    el.parentNode.removeChild(el);
    return out;
  }
  // bold words then a line break at the start: the bold words become a subheading above the paragraph
  function lead(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode()) && !txt(n)) {}
    if (!n) return;
    var b = n.parentElement.closest('strong,b');
    if (!b || !el.contains(b) || txt(b).length > 90) return;
    var nx = b.nextSibling, up = b;
    while (!nx && up.parentNode !== el) { up = up.parentNode; nx = up.nextSibling; }
    while (quiet(nx)) nx = nx.nextSibling;
    if (!nx || nx.nodeName !== 'BR') return;
    el.parentNode.insertBefore(head(txt(b)), el);
    nx.parentNode.removeChild(nx); b.parentNode.removeChild(b);
    while (el.firstChild && (quiet(el.firstChild) || el.firstChild.nodeName === 'BR')) el.removeChild(el.firstChild);
  }
  function tidy(root) {
    if (root._tidy) return; root._tidy = 1;
    // one H1 a page: a heading typed as H1 in the text is a sub heading (an empty one goes)
    Array.prototype.slice.call(root.querySelectorAll('h1')).forEach(function (h) {
      if (blank(h)) { h.parentNode.removeChild(h); return; }
      var h2 = document.createElement('h2'); while (h.firstChild) h2.appendChild(h.firstChild); h.parentNode.replaceChild(h2, h);
    });
    Array.prototype.slice.call(root.querySelectorAll('p,div')).forEach(function (el) {
      if (!el.parentNode) return;
      if (el.querySelector('p,div,ul,ol,table')) { // a wrapper: line breaks at its start or end only add space
        [['firstChild', 'nextSibling'], ['lastChild', 'previousSibling']].forEach(function (e) {
          var c = el[e[0]]; while (c && (quiet(c) || c.nodeName === 'BR')) { var x = c[e[1]]; el.removeChild(c); c = x; }
        });
        return;
      }
      if (blank(el)) { el.parentNode.removeChild(el); return; } // base.css spaces every paragraph the same
      split(el).forEach(function (e) {
        if (allBold(e)) { e.parentNode.replaceChild(head(txt(e)), e); return; }
        lead(e);
      });
    });
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('.rte'), tidy); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Tile titles (21 Oct 2026): only a word too long for its tile on its own breaks, with a hyphen
   ("PERSONALISED" in a phone's two columns). Every other word moves whole to the next line. */
(function () {
  'use strict';
  var c2;
  function esc(s) { return s.replace(/[&<>]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[ch]; }); }
  function run() {
    c2 = c2 || document.createElement('canvas').getContext('2d');
    Array.prototype.forEach.call(document.querySelectorAll('.tile-t'), function (el) {
      var w = el.clientWidth; if (!w) return;
      var cs = getComputedStyle(el), ls = parseFloat(cs.letterSpacing) || 0;
      if (!el.hasAttribute('data-t')) el.setAttribute('data-t', el.textContent);
      c2.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var out = el.getAttribute('data-t').split(/(\s+)/).map(function (p) {
        if (!p || /^\s+$/.test(p)) return p;
        return c2.measureText(p).width + ls * p.length > w ? '<span class="hy">' + esc(p) + '</span>' : esc(p);
      }).join('');
      if (el.innerHTML !== out) el.innerHTML = out;
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 120); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run); else window.addEventListener('load', run);
  window.addEventListener('resize', soon);
  document.addEventListener('DOMContentLoaded', run);
})();
